<template>
  <div id="invoice" v-if="loadData">
    <img
      src="../../../assets/images/custom/AVAJANG-Logo-black.png"
      class="watermark"
    />
    <div class="vx-row">
      <div class="vx-col lg:w-1/4 no-padding">
        <ul class="invoice-letter-bar text-right">
          <li>
            شماره سفارش:
            <!-- <b v-if="Invoice.stockDraftOrderContractInfoQuery && Invoice.stockDraftOrderContractInfoQuery.id">
              {{ 'APO-' + ('000' + Invoice.stockDraftOrderContractInfoQuery.id).substr(-3) + ('0000' + Invoice.basketId).substr(-4) }}
            </b>
            <b v-else> -->
            <b>
              {{ "APO-" + Invoice.basketId }}
            </b>
          </li>
        </ul>
      </div>

      <div class="vx-col lg:w-1/2 no-padding text-center">
        <h4 class="invoice-title">صورتحساب فروش کالا</h4>
      </div>
      <div class="vx-col lg:w-1/4 no-padding text-left">
        <!--<img src="@ViewBag.BarcodeImage" alt="" />-->
        <ul class="invoice-letter-bar float-right">
          <li>
            تاریخ:
            <div class="inline-block" style="direction: ltr">
              {{ Invoice.createOn }}
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-card">
          <img
            src="../../../assets/images/custom/greyback.png"
            style="
              width: 100%;
              height: 40px;
              position: relative;
              border-radius: 7px 7px 0 0;
            "
          />
          <div class="text-center invoice_header">
            <h5>مشخصات فروشنده</h5>
          </div>
          <div class="vx-card__body">
            <div class="vx-row">
              <div class="vx-col lg:w-1/2">
                <b>نام شخص حقیقی/حقوقی: </b> شرکت فناوران آواسیس (سهامی خاص)
              </div>
              <div class="vx-col lg:w-1/4 text-right">
                <b>شناسه ثبت: </b>471126
              </div>
              <div class="vx-col lg:w-1/4">
                <b>شماره اقتصادی: </b>411478597317
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col lg:w-1/2"><b>استان: </b>تهران</div>
              <div class="vx-col lg:w-1/4"><b>شهر: </b>تهران</div>
              <div class="vx-col lg:w-1/4 text-right">
                <b>کد پستی: </b>1516743405
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col lg:w-3/4">
                <b>نشانی: </b>تهران، ولیعصر، قبل از توانیر، نبش بخشندگان،
                ساختمان مدیکو، طبقه 8 پلاک 2303
              </div>
              <div class="vx-col lg:w-1/4 text-right">
                <b>تلفن: </b>8450-021
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-card">
          <img
            src="../../../assets/images/custom/greyback.png"
            style="
              width: 100%;
              height: 40px;
              position: relative;
              border-radius: 7px 7px 0 0;
            "
          />
          <div class="text-center invoice_header">
            <h5>مشخصات خریدار</h5>
          </div>
          <div class="vx-card__body">
            <div class="vx-row">
              <div class="vx-col lg:w-1/2">
                <b>نام شخص حقیقی/حقوقی: </b
                >{{ Invoice.stockDraftOrderPartyInfoQuery.name }}
              </div>
              <div
                class="vx-col lg:w-1/2"
                v-if="
                  Invoice.stockDraftOrderPartyInfoQuery.partyType ==
                    'Individual'
                "
              >
                <b>کد ملی/شناسه ملی: </b
                >{{
                  Invoice.stockDraftOrderPartyInfoQuery.socialSecurityNumber
                }}
              </div>
              <div
                class="vx-col lg:w-1/2"
                v-if="
                  Invoice.stockDraftOrderPartyInfoQuery.partyType == 'Legal'
                "
              >
                <b>شماره اقتصادی: </b
                >{{ Invoice.stockDraftOrderPartyInfoQuery.companyNationalId }}
              </div>
            </div>
            <div class="vx-row">
              <template
                v-for="item in Invoice.stockDraftOrderPartyInfoQuery
                  .addressesInfos"
              >
                <div v-if="item" :key="item" class="vx-col lg:w-1/4">
                  <b>استان: </b>{{ item.provinceInfo.name }}
                </div>
                <div v-if="item" :key="item" class="vx-col lg:w-1/4">
                  <b>شهر: </b>{{ item.provinceInfo.cityName }}
                </div>
              </template>
              <template
                v-for="item in Invoice.stockDraftOrderPartyInfoQuery
                  .addressesInfos"
              >
                <div v-if="item" :key="item" class="vx-col lg:w-1/4">
                  <b>کد پستی: </b>{{ item.postalCode }}
                </div>
              </template>
              <template
                v-for="item in Invoice.stockDraftOrderPartyInfoQuery
                  .addressesInfos.phones"
              >
                <div v-if="item" :key="item" class="vx-col lg:w-1/4">
                  <b>تلفن:</b>
                  <span v-if="item.area">{{ item.area }}-</span>
                  {{ item.number }}
                </div>
              </template>
            </div>
            <div class="vx-row">
              <template
                v-for="item in Invoice.stockDraftOrderPartyInfoQuery
                  .addressesInfos"
              >
                <div v-if="item" :key="item" class="vx-col w-full">
                  <b>نشانی: </b>{{ item.address }}
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-card">
          <img
            src="../../../assets/images/custom/greyback.png"
            style="
              width: 100%;
              height: 40px;
              position: relative;
              border-radius: 7px 7px 0 0;
            "
          />
          <div class="text-center invoice_header">
            <h5>مشخصات کالا</h5>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="custom-tbl invoice_table">
                <vs-table
                  :data="Invoice.stockDraftOrderItemQueries"
                  ref="table"
                >
                  <template slot="thead">
                    <vs-th>{{ $t("Row") }}</vs-th>
                    <vs-th>{{ $t("ItemCode") }}</vs-th>
                    <vs-th style="width: 500px">{{ $t("ProductName") }}</vs-th>
                    <vs-th>{{ $t("Count") }}</vs-th>
                    <vs-th>{{ $t("UnitPrice") }}</vs-th>
                    <vs-th>{{ $t("TotalAmount") }}(ریال)</vs-th>
                    <vs-th>{{ $t("SumOfDiscount") }}</vs-th>
                    <vs-th>{{
                      $t("TotalAmountAfterDeductionOfDiscounts")
                    }}</vs-th>
                    <vs-th>{{ $t("TotalTaxAmount") }}</vs-th>
                    <vs-th>{{ $t("TotalAmountWithTax") }}</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr
                      v-for="(tr, indextr) in data"
                      :data="tr"
                      :key="indextr"
                    >
                      <vs-td :data="data[indextr]">
                        {{ parseInt(indextr) + 1 }}
                      </vs-td>
                      <vs-td :data="data[indextr]">
                        {{
                          data[indextr].stockDraftOrderProductInfoQuery.itemCode
                        }}
                      </vs-td>
                      <vs-td
                        :data="
                          data[indextr].stockDraftOrderProductInfoQuery
                            .productName
                        "
                      >
                        {{
                          data[indextr].stockDraftOrderProductInfoQuery
                            .productName
                        }}
                      </vs-td>
                      <vs-td :data="data[indextr].count">
                        {{ data[indextr].count }}
                      </vs-td>
                      <vs-td :data="data[indextr].unitPrice">
                        {{ Number(data[indextr].unitPrice).toLocaleString() }}
                      </vs-td>
                      <vs-td :data="data[indextr].totalAmount">
                        {{ Number(data[indextr].totalAmount).toLocaleString() }}
                      </vs-td>
                      <vs-td :data="data[indextr].sumOfDiscount">
                        <span v-if="data[indextr].sumOfDiscount">
                          {{
                            Number(data[indextr].sumOfDiscount).toLocaleString()
                          }}
                        </span>
                        <span v-else> - </span>
                      </vs-td>
                      <vs-td :data="data[indextr].totalTaxAmount">
                        {{
                          Number(
                            data[indextr].totalAmountAfterDeductionOfDiscounts
                          ).toLocaleString()
                        }}
                      </vs-td>
                      <vs-td :data="data[indextr].totalTaxAmount">
                        {{
                          Number(data[indextr].totalTaxAmount).toLocaleString()
                        }}
                      </vs-td>
                      <vs-td :data="data[indextr].price">
                        {{ Number(data[indextr].price).toLocaleString() }}
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td colspan="5" class="no_bborder text-left">
                        جمع کل
                      </vs-td>
                      <vs-td>-</vs-td>
                      <vs-td>-</vs-td>
                      <vs-td>-</vs-td>
                      <vs-td>-</vs-td>
                      <vs-td>
                        {{ Number(totalCount).toLocaleString() }}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            <div class="vx-col w-full">
              <div class="invoice-footer">
                <div class="mb-4">
                  {{ $t("ShippingFee") }} (ریال) :
                  <div class="border_wrapper">
                    {{ Number(Invoice.shippingFee).toLocaleString() }}
                  </div>
                </div>
                <div>
                  مبلغ به عدد (ریال) :
                  <div class="border_wrapper">
                    {{ Number(Invoice.totalAmountForPayment).toLocaleString() }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mx-6">
      <h6>
        این صورتحساب فقط جهت اطلاع مشتری بوده و فاقد ارزش قانونی می‌باشد.
      </h6>
      <h6 class="mt-6 mb-12">
        جهت دریافت اصل فاکتور،با هماهنگی به واحد مالی مراجعه گردد.
      </h6>
    </div>
    <div class="vx-row">
      <div class="vx-col lg:w-1/2">
        <b class="signature">مهر و امضا خریدار</b>
      </div>
      <div class="vx-col lg:w-1/2">
        <b class="signature">مهر و امضا فروشنده</b>
        <p class="sellername">نام فروشنده</p>
      </div>
    </div>

    <div class="vx-row hide-in-print">
      <div class="vx-col w-full">
        <vs-button type="filled" class="float-right" @click="$router.go(-1)">{{
          $t("Back")
        }}</vs-button>
        <vs-button
          type="button"
          class="float-right purple ml-4"
          @click="printWindow()"
          >{{ $t("Print") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>

<style>
@page {
  size: auto;
  margin: 0mm;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import "@/assets/scss/vuesax-rtl/_invoice.scss";

export default {
  name: " warehouseManagement_CheckOutTransactions_CheckOutInvice",
  data() {
    return {
      loadData: false,
      totalCount: null
    };
  },
  computed: {
    ...mapGetters({
      Invoice: "draftOrder/draftOrderInvoiceDetails"
    })
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      draftOrderInvoice: "draftOrder/draftOrderInvoice"
    }),
    load() {
      var id = this.$route.params.id;
      this.draftOrderInvoice(id).then(() => {
        setTimeout(() => {
          this.totalCount = this.Invoice.stockDraftOrderItemQueries.reduce(
            (acc, cur) => acc + Number(cur.price),
            0
          );
          this.loadData = true;
        }, 1500);
      });
    },
    printWindow() {
      window.print();
    }
  }
};
</script>
